import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { INewPasswordForm } from 'src/app/interfaces';
import { UsersService } from 'src/app/services/users.service';

@Component({
  selector: 'app-new-password',
  templateUrl: './new-password.component.html',
  styleUrls: ['./new-password.component.css']
})
export class NewPasswordComponent {
  constructor(public usersService: UsersService, private activatedRoute: ActivatedRoute, private router: Router, private snackBar: MatSnackBar) { }

  newPasswordForm: INewPasswordForm = {
    newPassword:'',
    confirmPassword:''
  }

  hide: boolean = true;

  handleNewPassword(){
    const token = this.activatedRoute.snapshot.paramMap.get('token');
    const email = this.activatedRoute.snapshot.paramMap.get('email');
    const newPassword = this.newPasswordForm.newPassword;
    const confirmPassword = this.newPasswordForm.confirmPassword;
    
    if(newPassword === confirmPassword) {
      this.usersService.newPassword(token, email, this.newPasswordForm).subscribe(
        () => {
          this.snackBar.open("Senha alterada com sucesso", "Fechar", {
            duration: 7000,
          })
          this.router.navigate(['/login']);
        },
        error => {
          console.log('error: ', error);
          this.snackBar.open("Não foi possível alterar a senha, tente novamente mais tarde", "Fechar", {
            duration: 7000,
          })
        });
    } else {
      this.snackBar.open("As senhas não coincidem, digite senhas iguais", "Fechar", {
          duration: 7000,
        })
    }
  }
}
